import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import logo from 'static/img/logo-andalucia.png';
import {url_rest, back_label, languages, types } from 'configuration'
import { getRequest, postRequest } from 'services/ApiService.js'

class  Header extends Component {
  // getRequest(url_rest + "/"+this.props.contentType+"/get/" + "42", this.this.props.lang).then(
  //   response => console.log(response.data)
  //   )
  constructor(props) {
    super(props);
    
    this.state = {}

    if (this.props.contentType == "recursos") {
      var data = {
        "item_number": 0,
        "page_size": 20,
        "filters": {}
      }
      data.filters["slug_" + this.props.lang] =  this.props.queryTerm
  
      postRequest(url_rest + "/resource/paginated", data , 'multi').then(
        (response) => {
          this.setState({result: response.data.list[0]})
        });
    }

    if (this.props.querySlug) {
      var data_slug = {
        "item_number": 0,
        "page_size": 20,
        "filters": {}
      }
      data_slug.filters["slug_" + this.props.lang] =  this.props.querySlug

      postRequest(url_rest + "/resource/paginated", data_slug, 'multi').then(
        (response) => {
          this.setState({result_slug: response.data.list[0]})
        });
    }

    if (this.props.queryType) {
      postRequest(url_rest + "/resource_type/paginated", {
        "item_number": 0,
        "page_size": 20,
        "filters": {
          "slug": this.props.queryType
        }
      } , this.props.lang).then(
        (response) => {
          this.setState({result_type: response.data.list[0].code})
        });
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps !== this.props) && this.props.queryType) {
      postRequest(url_rest + "/resource_type/paginated", {
        "item_number": 0,
        "page_size": 20,
        "filters": {
          "slug": this.props.queryType
        }
      } , this.props.lang).then(
        (response) => {
          this.setState({result_type: response.data.list[0].code})
        });
    }
  }
  
  printLanguages() {
    var href_es = window.location.origin+"/webapp/es/"+this.props.contentType
    var href_en = window.location.origin+"/webapp/en/"+this.props.contentType
    var href_fr = window.location.origin+"/webapp/fr/"+this.props.contentType
    var href_de = window.location.origin+"/webapp/de/"+this.props.contentType

    if (this.state.result) {
      href_es += "/"+this.state.result.slug_es
      href_en += "/"+this.state.result.slug_en
      href_fr += "/"+this.state.result.slug_fr
      href_de += "/"+this.state.result.slug_de
    }

    if (this.props.contentType == "destinos") {
      href_es += '/' + this.props.queryTerm
      href_en += '/' + this.props.queryTerm
      href_fr += '/' + this.props.queryTerm
      href_de += '/' + this.props.queryTerm
    }

    if (this.state.result_type) {
      href_es += '/' + types[this.state.result_type].slug.es
      href_en += '/' + types[this.state.result_type].slug.en
      href_fr += '/' + types[this.state.result_type].slug.fr
      href_de += '/' + types[this.state.result_type].slug.de
    }

    if (this.state.result_slug) {
      href_es += '/' + this.state.result_slug.slug_es
      href_en += '/' + this.state.result_slug.slug_en
      href_fr += '/' + this.state.result_slug.slug_fr
      href_de += '/' + this.state.result_slug.slug_de
    }

    

    return(
      <div className="custom-select language">
            <a href={href_es} className={this.href_active('es')}>{languages[this.props.lang].es}</a>
            <span style={{ 'margin-right': '0.5rem', 'padding-right': '10px' }}>|</span>
            <a href={href_en} className={this.href_active('en')}>{languages[this.props.lang].en}</a>
            <span style={{ 'margin-right': '0.5rem', 'padding-right': '10px' }}>|</span>
            <a href={href_fr} className={this.href_active('fr')}>{languages[this.props.lang].fr}</a>
            <span style={{ 'margin-right': '0.5rem', 'padding-right': '10px' }}>|</span>
            <a href={href_de} className={this.href_active('de')}>{languages[this.props.lang].de}</a>
          </div>
    )
  }

  href_active(lang) {
    if (lang == this.props.lang) return "active"
  }
  
  render() {
    return (
      <header>
        <a href="#" className={this.props.active + " nav-icon-menu icon-w45 toggle-menu"} onClick={this.props.clicker}><i className="fas fa-bars"></i></a>
        <a href="#" className={this.props.active + "nav-icon-menu icon-w60 toggle-menu-mb"} onClick={this.props.clicker}><i className="fas fa-bars"></i></a>

        <div className="logo">
          <img src={logo} className="logo-img" />
          {/* <label className="logo-title">Promoción de recursos turísticos</label> */}
        </div>
        {/*Searchbar for future developments
        <input type="text" placeholder="¿En qué puedo ayudarte?..." class="search-inputfield" />
        <a href="#" class="icon-w45 search-button"> <i class="fas fa-search"></i> </a> */}
        {this.printLanguages()}
        {/* <select className="language icon-w60"><option>ES</option><option>EN</option></select> */}
  
        <div onClick={this.props.history.goBack} className="back-btn resource-btn">
          <svg width="13px" height="10px" viewBox="0 0 13 10">
            <path d="M1,5 L11,5"></path>
            <polyline points="8 1 12 5 8 9"></polyline>
          </svg>
          <span>{back_label[this.props.lang]}</span>
        </div>
      </header>
    );
  }
  
}

export default withRouter(Header)


// WEBPACK FOOTER //
// ./src/components/Header.jsx